import React, { useEffect, useState } from "react";
import SC from "./style";
import { Tabs } from "@InnoUI/";
import theme from "@theme/";
import TSSReport from "./TSSReport";
import FileReport from "./FileReport";

const Reports = (props) => {
  const { popupState, setSelectedSubLevel = {}, selectedSubLevel } = props;
  const [selectedTab, setSelectedTab] = useState(0);

  const tabData = [
    { value: 0, label: "OSS Report" },
    { value: 1, label: "File Report" },
  ];

  useEffect(() => {
    setSelectedSubLevel(tabData[0]);
  }, []);

  const handleTabChange = (event, item) => {
    const data = tabData[item];
    setSelectedSubLevel(data);
    setSelectedTab(item);
  };

  return (
    <>
      <div style={{ margin: "0 10px 24px 10px" }}>
        <Tabs
          value={selectedTab}
          label={tabData.map((tab) => tab.label)}
          onChange={handleTabChange}
          selectedValue={selectedTab}
        />
      </div>
      {selectedTab == 0 && <TSSReport />}
      {selectedTab == 1 && <FileReport />}
    </>
  );
};

export default Reports;
